import { Component, Inject, OnInit } from '@angular/core';
import { IInvoiceInfo, USERS_PROFILE_SERVICE_TOKEN, UsersProfileServiceInterface } from '@cakeiteasy/web-utils';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { UserManager } from '../../../users/services/user.manager';
import { IUser } from '../../../users/models/i-user';
import { IPaymentInfo } from '../../../payment/models/i-payment-models';
import { getUser, getUserInvoiceInfo } from '../../../users/store/selectors';
import { UserState } from '../../../users/store/reducers/user.reducer';
import { take } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'billing-info',
  templateUrl: './billing-info.component.html',
  styleUrls: ['./billing-info.component.scss']
})
export class BillingInfoComponent implements OnInit {
  public user$: Observable<IUser>;
  public userInvoiceInfo$: Observable<IInvoiceInfo>;

  public isSaved: boolean;

  public isInvoiceInfoValid = false;
  public paymentInfo: IPaymentInfo;
  public bakeryId: number = null;

  constructor(@Inject(USERS_PROFILE_SERVICE_TOKEN) public profileService: UsersProfileServiceInterface,
              private _userStore: Store<UserState>,
              private _userManager: UserManager) {
  }

  async ngOnInit() {
    this.bakeryId = await this._getBakeryId();
    this.user$ = this._userStore.select(getUser);
    this.user$.subscribe((user: IUser) => this.paymentInfo = {
      userName: user.fullName,
      userEmail: user.email,
      userPhone: user.phone
    });
    this.userInvoiceInfo$ = this._userStore.select(getUserInvoiceInfo).pipe(take(1));
  }

  public onSaved() {
    this.isSaved = true;
  }

  private _getBakeryId() {
    if (this.profileService.getBakeryId) {
      return this.profileService.getBakeryId();
    }
  }
}
